exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pa-tabs{display:-ms-flexbox;display:-webkit-flex;display:flex;text-align:center}.pa-tabs li{margin-right:1px}.pa-tabs li a{display:block;width:100%;height:100%;padding:10px;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;text-decoration:none;border:1px solid}.pa-tabs li a.active{border-bottom:none}.pa-tab-pane{display:none}.pa-tab-pane.active{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?sourceMap!./src/js/framework/components/paTab.scss
// module id = 38
// module chunks = 0